//components/LoadingScreen/LoadingScreen.js
import React, { useEffect } from 'react';
import { CircularProgress, Backdrop, Typography } from '@mui/material';
import Fade from '@mui/material/Fade';
import { useLoading } from '../../contexts/LoadingContext'; // Updated to use LoadingContext2

const LoadingScreen = React.memo(() => {
  const { isLoading } = useLoading(); // Use LoadingContext to get the loading state

  // Log to monitor isLoading transitions
//  useEffect(() => {
//    console.log("[LoadingScreen] isLoading state changed:", isLoading);
//  }, [isLoading]);

  return (
    <Fade in={isLoading}>
      <Backdrop open={isLoading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="primary" size={80} aria-label="Loading" role="progressbar" />
        <Typography variant="body1" color="inherit" sx={{ mt: 2 }}>
          Loading...
        </Typography>
      </Backdrop>
    </Fade>
  );
});

export default LoadingScreen;
